
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequired26f"];
var parcelRegister = parcelRequire.register;
parcelRegister("2UlvM", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "Login", function () { return $c2e8ed3da86b745f$export$21a94553ffa41578; });
$parcel$export(module.exports, "default", function () { return $c2e8ed3da86b745f$export$2e2bcd8739ae039; });

var $2jF3M = parcelRequire("2jF3M");

var $8qQ3i = parcelRequire("8qQ3i");

var $OMilZ = parcelRequire("OMilZ");
var $jSBC1 = parcelRequire("jSBC1");
var $f6fu6 = parcelRequire("f6fu6");
var $braLr = parcelRequire("braLr");
var $eRtdj = parcelRequire("eRtdj");
var $bP8Jz = parcelRequire("bP8Jz");
var $izy1j = parcelRequire("izy1j");

var $l3TaJ = parcelRequire("l3TaJ");

var $hL37N = parcelRequire("hL37N");

var $hAypL = parcelRequire("hAypL");

var $9mM4t = parcelRequire("9mM4t");

var $cbk24 = parcelRequire("cbk24");

var $btP2y = parcelRequire("btP2y");
const $c2e8ed3da86b745f$export$21a94553ffa41578 = ()=>{
    const [searchParams, setSearchParams] = (0, $hL37N.useSearchParams)();
    const SO_UUID = searchParams.get("po");
    const uuid = searchParams.get("rfq");
    const [isMobileTablet] = (0, $izy1j.useMediaQuery)("(max-width: 768px)");
    const navigate = (0, $hL37N.useNavigate)();
    const dispatch = (0, $9mM4t.useDispatch)();
    const [rememberMe, setRememberMe] = (0, $8qQ3i.useState)(false);
    const basicValidation = $hAypL.object().shape({
        userName: (0, $cbk24.yupEmail),
        password: (0, $cbk24.yupPassword)
    });
    const onSubmit = async (event)=>{
        dispatch((0, $cbk24.setPageLoading)({
            loading: true,
            loadingText: "Logging you in..."
        }));
        try {
            const result = await dispatch((0, $cbk24.loginSupplier)(event.userName, event.password, uuid != null ? uuid : "", SO_UUID !== null ? SO_UUID : ""));
            if (result.status === 200) {
                navigate("/home");
                const uniqueUserId = await (0, $cbk24.get_doc)({
                    doc: "User ID",
                    fields: [
                        "id"
                    ],
                    filters: [
                        [
                            "name",
                            "=",
                            event.userName
                        ]
                    ]
                });
                if (uniqueUserId?.status === 200) {
                    dispatch({
                        type: (0, $cbk24.USERID_FETCH_SUCCESS),
                        payload: {
                            uniqueUserId: uniqueUserId?.data.data[0]?.id
                        }
                    });
                    window.dataLayer?.push({
                        event: "User Login",
                        user_id: uniqueUserId?.data.data[0]?.id,
                        user_email: event.userName,
                        page_url: window.location.href,
                        page_name: window.location.pathname,
                        success: true
                    });
                    (0, $btP2y.Mixpanel).track("login", {
                        event: "User Login",
                        user_id: uniqueUserId?.data.data[0]?.id,
                        user_email: event.userName,
                        page_url: window.location.href,
                        page_name: window.location.pathname,
                        success: true
                    });
                }
                dispatch((0, $cbk24.setPageLoading)({
                    loading: false,
                    loadingText: ""
                }));
                dispatch({
                    type: (0, $cbk24.SET_MESSAGE),
                    payload: {
                        case: (0, $cbk24.SUCCESS_MSG),
                        data: "Logged in"
                    }
                });
                navigate("/home");
            }
        } catch (error) {
            window.dataLayer?.push({
                event: "User Login",
                user_email: event.userName,
                page_url: window.location.href,
                page_name: window.location.pathname,
                success: false
            });
            (0, $btP2y.Mixpanel).track("loginFailed", {
                event: "User Login",
                user_email: event.userName,
                page_url: window.location.href,
                page_name: window.location.pathname,
                success: false
            });
            dispatch((0, $cbk24.setPageLoading)({
                loading: false,
                loadingText: ""
            }));
            dispatch({
                type: (0, $cbk24.SET_MESSAGE),
                payload: {
                    case: (0, $cbk24.ERROR_MSG),
                    data: (0, $cbk24.formatErrorMessage)(error)
                }
            });
        }
    };
    return /*#__PURE__*/ (0, $2jF3M.jsx)((0, $OMilZ.Box), {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexDirection: "column",
        h: "100%",
        bg: {
            base: "linear-gradient(175.96deg, #379179 -188.68%, #79C4B0 114.46%)",
            lg: "#fff"
        },
        children: /*#__PURE__*/ (0, $2jF3M.jsxs)((0, $OMilZ.Box), {
            display: "flex",
            flexDir: "column",
            h: {
                base: "100%",
                lg: "auto"
            },
            w: {
                base: "100%",
                lg: "auto"
            },
            mt: {
                base: "2rem",
                lg: "0"
            },
            children: [
                /*#__PURE__*/ (0, $2jF3M.jsxs)((0, $f6fu6.Flex), {
                    mb: "1.5rem",
                    flexDirection: "column",
                    justifyContent: "center",
                    px: {
                        base: "1rem",
                        lg: 0
                    },
                    children: [
                        /*#__PURE__*/ (0, $2jF3M.jsx)((0, $bP8Jz.Text), {
                            textStyle: "primary.poster",
                            color: !isMobileTablet ? "#000" : "#fff",
                            children: "Login"
                        }),
                        /*#__PURE__*/ (0, $2jF3M.jsx)((0, $bP8Jz.Text), {
                            textStyle: "primary.text",
                            color: !isMobileTablet ? "#000" : "#fff",
                            children: "Welcome back!"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $2jF3M.jsx)((0, $OMilZ.Box), {
                    borderRadius: {
                        base: "1rem 1rem 0 0",
                        lg: "none"
                    },
                    bg: "#fff",
                    flexGrow: 1,
                    pt: {
                        base: "2rem",
                        lg: "0"
                    },
                    children: /*#__PURE__*/ (0, $2jF3M.jsx)((0, $l3TaJ.Formik), {
                        initialValues: {
                            userName: "",
                            password: "",
                            remember: false
                        },
                        validationSchema: basicValidation,
                        onSubmit: onSubmit,
                        children: (formik)=>{
                            return /*#__PURE__*/ (0, $2jF3M.jsx)((0, $l3TaJ.Form), {
                                id: "signinsupplier",
                                className: "suppliersignin",
                                children: /*#__PURE__*/ (0, $2jF3M.jsxs)((0, $braLr.Grid), {
                                    templateColumns: {
                                        xs: "repeat(1,1fr)"
                                    },
                                    gap: 5,
                                    children: [
                                        /*#__PURE__*/ (0, $2jF3M.jsx)((0, $eRtdj.GridItem), {
                                            px: {
                                                base: "1rem",
                                                lg: 0
                                            },
                                            children: /*#__PURE__*/ (0, $2jF3M.jsx)((0, $cbk24.RenderTextField), {
                                                label: "Email ID",
                                                name: "userName",
                                                type: "email",
                                                placeholder: "Enter Email Address",
                                                isMandatory: true
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2jF3M.jsxs)((0, $eRtdj.GridItem), {
                                            px: {
                                                base: "1rem",
                                                lg: 0
                                            },
                                            children: [
                                                /*#__PURE__*/ (0, $2jF3M.jsx)((0, $cbk24.RenderTextField), {
                                                    label: "Password",
                                                    name: "password",
                                                    type: "password",
                                                    placeholder: "********",
                                                    isMandatory: true
                                                }),
                                                /*#__PURE__*/ (0, $2jF3M.jsxs)((0, $f6fu6.Flex), {
                                                    justifyContent: "space-between",
                                                    mt: {
                                                        base: 6,
                                                        lg: 1
                                                    },
                                                    children: [
                                                        /*#__PURE__*/ (0, $2jF3M.jsx)((0, $OMilZ.Box), {
                                                            display: "flex",
                                                            justifyContent: "center",
                                                            alignItems: "center",
                                                            children: /*#__PURE__*/ (0, $2jF3M.jsx)((0, $jSBC1.Checkbox), {
                                                                isChecked: rememberMe,
                                                                onChange: ()=>{
                                                                    setRememberMe((prevState)=>!rememberMe);
                                                                },
                                                                colorScheme: "green",
                                                                children: /*#__PURE__*/ (0, $2jF3M.jsx)((0, $bP8Jz.Text), {
                                                                    textStyle: "primary.text",
                                                                    children: "Remember me"
                                                                })
                                                            })
                                                        }),
                                                        /*#__PURE__*/ (0, $2jF3M.jsx)((0, $hL37N.Link), {
                                                            to: `/forgotPassword${uuid != null ? `/?rfq=${uuid}` : ""}${SO_UUID != null ? `/?po=${SO_UUID}` : ""}`,
                                                            children: /*#__PURE__*/ (0, $2jF3M.jsx)((0, $bP8Jz.Text), {
                                                                _hover: {
                                                                    textDecoration: "underline"
                                                                },
                                                                textStyle: "primary.secondaryText",
                                                                children: "Forgot password?"
                                                            })
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $2jF3M.jsx)((0, $eRtdj.GridItem), {
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            mt: {
                                                base: "1rem",
                                                lg: "3.375rem"
                                            },
                                            px: {
                                                base: "1rem",
                                                lg: 0
                                            },
                                            children: /*#__PURE__*/ (0, $2jF3M.jsx)((0, $cbk24.DarkButton), {
                                                id: "supplier_user_login_btn",
                                                type: "submit",
                                                className: "suppliersignin",
                                                width: {
                                                    base: "100%",
                                                    lg: "23.75rem"
                                                },
                                                height: "50px",
                                                children: "Log In",
                                                bg: "#4BA18A",
                                                _hover: {
                                                    bg: "#38846D"
                                                }
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $2jF3M.jsx)((0, $eRtdj.GridItem), {
                                            px: {
                                                base: "1rem",
                                                lg: 0
                                            },
                                            children: /*#__PURE__*/ (0, $2jF3M.jsxs)((0, $OMilZ.Box), {
                                                display: "flex",
                                                justifyContent: {
                                                    base: "center",
                                                    lg: "left"
                                                },
                                                children: [
                                                    /*#__PURE__*/ (0, $2jF3M.jsx)((0, $bP8Jz.Text), {
                                                        textStyle: "primary.secondaryText",
                                                        children: "Don't have an account?"
                                                    }),
                                                    /*#__PURE__*/ (0, $2jF3M.jsxs)((0, $bP8Jz.Text), {
                                                        textStyle: "primary.bold",
                                                        sx: {
                                                            fontWeight: "600"
                                                        },
                                                        as: (0, $hL37N.Link),
                                                        to: `/register${uuid != null ? `/?rfq=${uuid}` : SO_UUID != null ? `/?po=${SO_UUID}` : ""}`,
                                                        color: isMobileTablet ? "#4BA18A" : "",
                                                        children: [
                                                            "\xa0",
                                                            /*#__PURE__*/ (0, $2jF3M.jsx)("span", {
                                                                style: {
                                                                    color: "#4BA18A"
                                                                },
                                                                children: "Sign Up"
                                                            })
                                                        ]
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            });
                        }
                    })
                })
            ]
        })
    });
};
var $c2e8ed3da86b745f$export$2e2bcd8739ae039 = $c2e8ed3da86b745f$export$21a94553ffa41578;

});


//# sourceMappingURL=Login.92d0f38f.js.map
